import React, { useState } from 'react';
import HomeSlide from './Components/HomeSlide';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination, A11y, Mousewheel, Keyboard } from 'swiper';

import 'swiper/swiper.scss';

import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

import classes from './css/Home.module.css';
import '../index.css';
SwiperCore.use([Navigation, Pagination, A11y,Mousewheel, Keyboard]);

const Home = () => {

    // TRUMP SLIDE
    const slides = [];
      slides.push(
        <SwiperSlide key={Math.random}
        >
          <HomeSlide 
            color={'orange'}
            pillImg={'trump'}
            title={['SUPER' , <br/> ,' TRUMP']}
            subTitle={'happiness as if you stole the presidency'}
            rating={4}
            priceBTC={0.0021}
            priceETH={0.0802}
            desc={'The Super Trump is our go-to recommendation for a night of pure ecstasy, with effects lasting for up to 6 hours, but without the comedown of being impeached twice.'}
            content={80}
          />
        </SwiperSlide>
      );
      

    //TESLA SLIDE
      slides.push(
        <SwiperSlide key={Math.random}
        >
          <HomeSlide 
            color={'blue'}
            pillImg={'tesla'}
            title={'TESLA'}
            subTitle={'You will feel better than Elon Musk on his best day.'}
            rating={4}
            priceBTC={0.0023}
            priceETH={0.0841}
            desc={'The Tesla is your first class ticket to Mars aboard the Falcon 99, with effects lasting for up to 8 hours.'}
            content={100}
          />
        </SwiperSlide>
      );

  





    return ( <div className={classes.slideContainer}>

        <Swiper
        navigation
        mousewheel
        keyboard={{enabled: true, pageUpDown: true}}
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log('slide change')}
        className={classes.slider}
      >
                <SwiperSlide key={Math.random} className={`${classes.s1} ${classes.slide}`}>
                    <h1>PUREST MOLLY</h1>
                    <h1>TO YOUR DOORSTEP</h1>
                    <div className={classes.callContainer}>
                        <Link to="/Shop" className={classes.callToAction}>SHOP NOW</Link>
                    </div>
                </SwiperSlide>
          {slides} 
      </Swiper>

      
      </div>
        
    )
};

export default Home;
